window.autoSlideHero;
window.slidesInterval;

var slides = document.querySelectorAll('#slides .slide');

if(slides.length) {
	var currentSlide = 0,
		slidesLength = slides.length-1;

	autoSlideHero = function() {
		if(document.visibilityState === 'visible')
			setCurrentSlide('next');
	};

	slidesInterval = setInterval(autoSlideHero, 7000);
}

window.setCurrentSlide = function setCurrentSlide(isNext) {
	Velocity(slides[currentSlide], {opacity: [0,1]}, {duration: 600, display: 'none'});

	currentSlide = isNext ? (currentSlide == slidesLength ? 0 : ++currentSlide) : (currentSlide == 0 ? slidesLength : --currentSlide);

	var bg = slides[currentSlide].querySelector('.bg-container.hidden');

	if(bg) {
		imgLazyLoad(bg, 0);
		bg.classList.remove('hidden');
	}

	Velocity(slides[currentSlide], {opacity: [1,0]}, {duration: 600, display: 'block'});
}